import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { ZCatalogClassifierItem } from "src/business/catalog/ZCatalog";
import {
  ClassifierFilters,
  classifiersLoader,
  ZClassifier,
} from "src/business/classifier";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import {
  makeMdmActionColumn,
  MdmTable,
  RenderButtonAction,
} from "src/components/MdmTable";
import { ColumnFiltersDict } from "src/components/ReactiveTable/components/AntDropdownFilter";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import {
  LocalClassifierLoader,
  LocalClassifiersFilter,
} from "../LocalClassifierLoader";
import { ClassifiersAddModal } from "./ClassifiersAddModal";
import * as styles from "./ClassifiersSelect.module.less";

type PropsClassifiersSelect = {
  value?: ZCatalogClassifierItem[];
  onChange?(newValue: ZCatalogClassifierItem[]): void;
  tableStore: RtStore<ZCatalogClassifierItem, LocalClassifiersFilter>;
  loader: LocalClassifierLoader;
};

const cvtClassifier = (src: ZClassifier): ZCatalogClassifierItem => ({
  id: src.id,
  displayId: src.displayId,
  name: src.name,
  description: src.description,
});

export const ClassifiersSelect: React.FC<PropsClassifiersSelect> = (props) => {
  const { value, onChange, tableStore, loader } = props;
  const [addStore, setAddStore] =
    React.useState<RtStore<ZClassifier, ClassifierFilters>>();
  React.useEffect(() => {
    loader.setData(value ?? []);
  }, [value]);
  const remove = (removeId: string) => {
    const rows = tableStore.rows.filter(({ id }) => id !== removeId);
    onChange?.(rows);
  };
  const onAddOpen = () => {
    setAddStore(
      new RtStore({
        rowKey: "id",
        loader: classifiersLoader,
        selectionType: "checkbox",
      }),
    );
  };
  const onAddFinish = (list: ZClassifier[]) => {
    const used = new Set(value?.map(({ id }) => id));
    const selected: ZCatalogClassifierItem[] = list
      .filter(({ id }) => !used.has(id))
      .map(cvtClassifier);
    onChange?.([...(value || []), ...selected]);
    setAddStore(undefined);
  };

  const columnFilters: ColumnFiltersDict = {
    // -- что-то эти фильтры пока плохо работают. первый срабатывает нормально, второй уже не работает. надо отлаживать
    // name: textColumnFilter(
    //   () => tableStore.filters?.name,
    //   (text) => tableStore.changeSingleFilter("name", text || undefined),
    // ),
    // description: textColumnFilter(
    //   () => tableStore.filters?.name,
    //   (text) => tableStore.changeSingleFilter("description", text || undefined),
    // ),
  };

  // verticalMode="fit" - не работает. Потому что в момент вычисления высоты контейнер имеет display=none и высота = 0.
  // Пока не понятно, можно ли с этим что-то сделать.
  return (
    <ToolBox2
      mainTool={
        <div className={styles.title}>Связь каталога с классификаторами</div>
      }
      extraTools={
        <Button icon={<PlusOutlined />} onClick={onAddOpen}>
          Добавить
        </Button>
      }
    >
      <MdmTable
        store={tableStore}
        columns={columns(remove)}
        verticalMode="normal"
        resizableColumns
        columnFilters={columnFilters}
      />
      <ClassifiersAddModal
        store={addStore}
        close={() => setAddStore(undefined)}
        onSelect={onAddFinish}
      />
    </ToolBox2>
  );
};

const columns = (
  remove: (id: string) => void,
): RtColumn<ZCatalogClassifierItem>[] => [
  {
    ...columnDisplayId,
    sort: true,
  },
  {
    key: "name",
    title: "Название",
    render: ({ id, name }) => (
      <BlankLink
        href={makeUrl(PageUrl.managementClassifierCard, { id })}
        title="Открыть карточку классификатора в новой вкладке"
      >
        {name}
      </BlankLink>
    ),
    width: "30%",
    minWidth: 200,
    sort: true,
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
    sort: true,
  },
  makeMdmActionColumn<ZCatalogClassifierItem>({
    key: "delete",
    render: (row) => (
      <RenderButtonAction
        icon={<DeleteOutlined />}
        title={`Удалить связь с классификатором "${row.name}"`}
        onClick={() => remove(row.id)}
      />
    ),
  }),
];
